import {
  get as getCookie,
  remove as removeCookie,
} from "../js/utils/cookie/cookie";
import { COOKIES } from "../js/constants";

export default class giftCertificate {
  /**
   * Creates a tracking instance that handles form events in gift donation thank you page.
   */
  constructor() {
    this.config = {
      selectors: {
        giftCertificate: ".Tracking--giftCertificate",
      },
    };

    this.giftCertificate = document.querySelector(
      this.config.selectors.giftCertificate
    );

    if (this.giftCertificate) {
      giftCertificate._bindCookies();
    }
  }

  /**
   * binds cookies
   *
   * @static
   * @private
   */
  static _bindCookies() {
    const giftDonationFormNameCookie = getCookie(
      COOKIES.GIFT_DONATION_FORM_NAME
    );
    const selectedMotiveCookie = getCookie(COOKIES.SELECTED_MOTIVE);
    if (selectedMotiveCookie && giftDonationFormNameCookie) {
      giftCertificate._dataLayerPush(
        selectedMotiveCookie,
        giftDonationFormNameCookie
      );
    }
  }

  /**
   * pushes data to dataLayer removes cookie
   * happens on "checkout" page
   *
   * @static
   * @private
   * @param {string} selectedMotive
   * @param {string} giftDonationFormName
   */
  static _dataLayerPush(selectedMotive, giftDonationFormName) {
    window.dataLayer.push({
      event: "Event",
      event_name: "geschenkspendeformular_motivauswahl",
      geschenkspendeformular_submit: {
        geschenkspendeformular_name: giftDonationFormName,
        pp_event_category: "geschenkspendeformular",
        pp_event_action: "step-Motivauswahl",
        pp_event_name: selectedMotive,
      },
    });

    removeCookie(COOKIES.GIFT_DONATION_FORM_NAME, { path: "/" });
    removeCookie(COOKIES.SELECTED_MOTIVE, { path: "/" });
  }
}
